import React from 'react';
import { Quote } from 'lucide-react';
import { motion, useReducedMotion } from 'framer-motion';
import { CLIENT_LOGOS } from '../../lib/constants';
import { Eyebrow } from '../ui/Section';
const outcomes = [{
  value: '<45 days',
  label: 'Cloud transition completed',
  colour: 'bg-ct-deep'
}, {
  value: '<2 hours',
  label: 'Reported user downtime',
  colour: 'bg-managed-deep'
}, {
  value: '<12 months',
  label: 'Reported return on investment',
  colour: 'bg-hosting-deep'
}];
export function ClientProofWall() {
  const reduceMotion = useReducedMotion();
  return <section id="outcomes" className="overflow-hidden bg-navy py-12 text-white md:py-16" aria-label="Client proof" data-id="element-143" data-mp="1f5aufsbr1zn3">
      <div className="mx-auto max-w-content px-5 md:px-8" data-id="element-144" data-mp="166fl47des9fk">
        <div className="grid gap-6 lg:grid-cols-2 lg:items-end" data-id="element-145" data-mp="1680gfz7jrweh">
          <div data-id="element-146" data-mp="117m9ylllguik">
            <Eyebrow onDark color="var(--svc-red-soft)" data-id="element-147" data-mp="1161fsx36zdl8">Client perspective</Eyebrow>
            <h2 className="mt-5 max-w-xl font-display text-[34px] font-black leading-[1.04] tracking-tight md:text-[48px]" data-id="element-148" data-mp="w7zyohpbtoce">Proof should answer the questions a promise cannot.</h2>
          </div>
          <p className="max-w-xl text-[16px] leading-relaxed text-white/72 lg:justify-self-end" data-id="element-149" data-mp="io51602grhgm">Did CT Group understand the urgency? Was responsibility clear? Did the work deliver the result reported? The evidence below is drawn from published client work.</p>
        </div>

        <motion.div initial={reduceMotion ? undefined : {
        y: 14
      }} whileInView={reduceMotion ? undefined : {
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.24,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-10 grid gap-px bg-white/15 lg:grid-cols-5" data-id="element-150" data-mp="wno7qofmmkqt">
          <blockquote className="flex min-h-[220px] flex-col justify-between bg-white p-6 text-navy lg:col-span-2 md:p-7" data-id="element-151" data-mp="rnjst2ud9y2p">
            <Quote className="h-7 w-7 text-security" aria-hidden data-id="element-152" data-mp="37e61tt79n9md" />
            <p className="my-6 font-display text-[22px] font-bold leading-snug md:text-[25px]" data-id="element-153" data-mp="3cf2d4rty5y1t">“CT Group delivered what was promised, within the urgent timeframe and budget.”</p>
            <cite className="text-[12px] not-italic text-slate" data-id="element-154" data-mp="1dx8pqhirhgt3">Practice manager · Published legal case study</cite>
          </blockquote>
          {outcomes.map(item => <article key={item.value} className={`flex min-h-[220px] flex-col justify-end p-6 ${item.colour}`} data-id="element-155" data-mp="193xem46x2dvd">
              <p className="font-display text-[32px] font-black" data-id="element-156" data-mp="z846cx08d6je">{item.value}</p>
              <p className="mt-2 text-[12px] leading-relaxed text-white/85" data-id="element-157" data-mp="z5zrjk0smn4c">{item.label}</p>
            </article>)}
        </motion.div>

        <ul className="grid grid-cols-2 gap-px bg-border md:grid-cols-3 lg:grid-cols-6" data-id="element-158" data-mp="q6mhap4uhuik">
          {CLIENT_LOGOS.map(logo => <li key={logo.name} className="flex min-h-[120px] items-center justify-center bg-white px-5 py-5" data-id="element-159" data-mp="l9w2040v72y7">
              <img src={logo.src} alt={logo.name} style={{
            transform: `scale(${logo.scale})`
          }} className="h-14 w-full max-w-[150px] object-contain" data-id="element-160" data-mp="2kjcmi30nyq59" />
            </li>)}
        </ul>
        <div className="mt-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between" data-id="element-161" data-mp="2n5le4o2yjxnd"><p className="text-[11px] text-white/65" data-id="element-162" data-mp="2s3dg6axbh05a">Historical case-study results. Individual outcomes vary.</p><a href="https://ctgroup.com.au/case-studies/" className="text-[13px] font-bold text-ct-light underline decoration-white/25 underline-offset-4 hover:decoration-ct-light" data-id="element-163" data-mp="2ww6m324iueiy">Explore published case studies</a></div>
      </div>
    </section>;
}